import React from 'react';
import Fadeup from '../fadeup/Fadeup';

function OurHistory() {
  return (
    <section className="sec_pd">
      <div className="container">
        <Fadeup delay={0.3}>
        <h3 className="text-center mt-5 mb-4 mx-3 pb-2 text-black fs_40">
        Our History
      </h3>
        </Fadeup>
     <Fadeup delay={0.2}>
     <p className="text-center mb-4 mx-3 border-bottom pb-2 text-black">
        Our journey began with a single vision: to bring together collectors and enthusiasts of art in an extraordinary space.<br /> From humble beginnings, we've established a community of connoisseurs who share a passion for the unique and the exceptional.
      </p>
     </Fadeup>
        <div className="row mt-5">
          <div className="col-12">
            <ul className="list-group">
              <li className="list-group-item">
                <strong>2015 - </strong>Vision formed from the owner’s private collector network.
              </li>
              <li className="list-group-item">
                <strong>2016 - </strong>First closed-door auction for collectors held at a historical mansion.
              </li>
              <li className="list-group-item">
                <strong>2018 - </strong>Formal launch of Anachronistic Auction House and opening of our London
                gallery.
              </li>
              <li className="list-group-item">
                <strong>2020 - </strong>Digital transformation with live-stream bidding and virtual catalogs.
              </li>
              <li className="list-group-item">
                <strong>2022 - </strong>Global expansion to Europe, North America, and the Middle East.
              </li>
              <li className="list-group-item">
                <strong>2024 - </strong>Strategic partnerships with museums and cultural institutions.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}

export default OurHistory;
